module.exports = __webpack_public_path__ + "img/icon_instagram_swipe_up.9659b0a6.svg";